import { render, staticRenderFns } from "./TransferAmountSetting.vue?vue&type=template&id=0e8dcd29&scoped=true"
import script from "./TransferAmountSetting.vue?vue&type=script&lang=js"
export * from "./TransferAmountSetting.vue?vue&type=script&lang=js"
import style0 from "./TransferAmountSetting.vue?vue&type=style&index=0&id=0e8dcd29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8dcd29",
  null
  
)

export default component.exports